export const getHasInvoicesAboveRemainingAuth = (invoicedSpends) => (
  Object.values(invoicedSpends).some((amount) => amount < 0)
);

export const getCanBulkActionAllInvoices = (
  selectedRows,
  invoicedSpends,
  invoiceFsps,
) => (
  selectedRows.every((invoice) => {
    const authId = invoice.service_authorization?.id;
    return !authId ||
      invoicedSpends[authId] >= 0 ||
      invoiceFsps[invoice.id]?.can_invoice_above_remaining_authorized_amount;
  })
);

export const getErroredInvoiceIds = (
  selectedRows,
  invoicedSpends,
  invoiceFsps,
) => new Set(
  selectedRows
    .filter((invoice) => {
      const authId = invoice.service_authorization?.id;
      return authId &&
        invoicedSpends[authId] < 0 &&
        !invoiceFsps[invoice.id]?.can_invoice_above_remaining_authorized_amount;
    })
    .map((invoice) => invoice.id),
);
